import i18next, { type i18n as I18nInstance } from "i18next";
import { initReactI18next } from "react-i18next";

/**
 * Shared i18next instance for the web app.
 *
 * Phase 0: minimal init (default `it`, `en` fallback) so `main.tsx` can mount
 * the `I18nextProvider`. Phase 3 wires this same instance into
 * `@praesto/core` i18n so modules register their namespaces via
 * `core.i18n.registerModuleTranslations(...)` at load time.
 */
export const i18n: I18nInstance = i18next.createInstance();

void i18n.use(initReactI18next).init({
  lng: "it",
  fallbackLng: "en",
  defaultNS: "core",
  ns: ["core"],
  resources: {
    it: { core: {} },
    en: { core: {} },
  },
  interpolation: { escapeValue: false },
});
